import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { GoogleAuthProvider } from './GoogleAuthProvider';
import LandingPage from './components/LandingPage/LandingPage';
import LoginPage from './components/Login/LoginPage';
import MainLayout from './components/Layout/MainLayout';
import DashboardPage from './components/Dashboard/DashboardPage';
import PipelinePage from './components/Pipeline/PipelinePage';
import PlaceRequestPage from './components/LeadGen/PlaceRequestPage';
import LeadRequestsPage from './components/LeadGen/LeadRequestsPage';
import PreQualifiedLeadsPage from './components/LeadGen/PreQualifiedLeadsPage';
import QualifiedReadyLeadsPage from './components/LeadGen/QualifiedReadyLeadsPage';
import CallAgentPage from './components/CallAgent/CallAgentPage';
import WhatsAppAgentPage from './components/AgentPages/WhatsAppAgentPage';
import EmailAgentPage from './components/AgentPages/EmailAgentPage';
import LinkedInOutreachPage from './components/AgentPages/LinkedInOutreachPage';
import LinkedInPostCommentPage from './components/AgentPages/LinkedInPostCommentPage';
import MeetingsPage from './components/Meetings/MeetingsPage';
import SettingsPage from './components/Settings/SettingsPage';
import PrivacyPage from './components/Legal/PrivacyPage';
import TermsPage from './components/Legal/TermsPage';
import './landing.css';

const ProtectedLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <MainLayout>
      {children}
    </MainLayout>
  );
};

function App() {
  return (
    <AuthProvider>
      <GoogleAuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/app/*" element={
              <ProtectedLayout>
                <Routes>
                  <Route path="/" element={<Navigate to="/app/dashboard" replace />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/pipeline" element={<PipelinePage />} />
                  <Route path="/lead-gen/place-request" element={<PlaceRequestPage />} />
                  <Route path="/lead-gen/requests" element={<LeadRequestsPage />} />
                  <Route path="/lead-gen/pre-qualified" element={<PreQualifiedLeadsPage />} />
                  <Route path="/lead-gen/qualified" element={<QualifiedReadyLeadsPage />} />
                  <Route path="/call-agent" element={<CallAgentPage />} />
                  <Route path="/whatsapp-agent" element={<WhatsAppAgentPage />} />
                  <Route path="/email-agent" element={<EmailAgentPage />} />
                  <Route path="/linkedin-agent/outreach" element={<LinkedInOutreachPage />} />
                  <Route path="/linkedin-agent/post-comment" element={<LinkedInPostCommentPage />} />
                  <Route path="/meetings" element={<MeetingsPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                </Routes>
              </ProtectedLayout>
            } />
          </Routes>
        </Router>
      </GoogleAuthProvider>
    </AuthProvider>
  );
}

export default App;